import ClubInvoice from '../dto/ClubInvoice';

export default class DunningChecker {
    isDunningDisabled(clubDunningSettings) {
        return clubDunningSettings === null || clubDunningSettings.enabled === false;
    }

    isDunningDisabledForInvoice(clubInvoice, includeCurrentDunningStatus) {
        if (includeCurrentDunningStatus && clubInvoice.dunningStatus.status > 0) {
            return false;
        }
        return clubInvoice.canceled
            || clubInvoice.isReverseInvoice
            || clubInvoice.invoiceRecipient.dunningStopActive
            || clubInvoice.gross.data.numerator <= 0
            || clubInvoice.status.status === ClubInvoice.STATUS_PAID
            || (clubInvoice.status.status === ClubInvoice.STATUS_UNEQUAL && clubInvoice.isPayoffRequired());
    }

    isDunningLevelDisabledForInvoice(clubInvoice, level) {
        return !clubInvoice.enabledDunningStatus.includes(level);
    }

    isBulkInvoiceSelectionDisabled(clubInvoice) {
        if (this.isDunningDisabledForInvoice(clubInvoice, false)) {
            return true;
        }
        if (clubInvoice.enabledDunningStatus.length === 0) {
            return true;
        }
        const enabledDunningStatus = clubInvoice.enabledDunningStatus.filter((enabledStatus) => enabledStatus > clubInvoice.dunningStatus.status);
        return enabledDunningStatus.length === 0;
    }
}
